
import axios from "axios";

const svrUrl = process.env.REACT_APP_SERVER_URL;//svrUrl = 'http://localhost:8000';

// async function getS3Path(imagePath, sec=60000) {
//   try {
//     const imgUrl = await fetchImageUrl(imagePath, sec);
//     return imgUrl;
//   } catch (error) {
//     console.error('Error in getImgUrl:', error);
//   }
// }


async function getS3Path(imagePath, sec=60000) {
  const url = `${svrUrl}/get-image-path`;
  // console.log(url, 'url');
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



async function getS3PathDownLoad_rename(imagePath, fileName, sec=600) {
  // const imagePath = 'bbb.jpeg'; // 서버에 요청할 파일 이름
  try {
    const imgUrl = await fetchImageUrl_rename(imagePath, fileName, sec);
    return imgUrl;
  } catch (error) {
    console.error('Error in getImgUrl:', error);
  }
}


async function fetchImageUrl_rename(imagePath, fileName, sec) {
  const url = `${svrUrl}/get-image-path-rename`;
  try {
    const response = await axios.post(url, {
      imagePath: imagePath,
      fileName: fileName,
      sec: sec
    });
    if (response.data.url) {
      return response.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}




// async function fetchImageUrl_rename(imagePath, fileName, sec) {

//   try {
//     const response = await axios.get(`http://localhost:8000/get-image-path-rename`, {
//       params: { imagePath, fileName, sec } // 쿼리 파라미터로 imagePath 전달
//     });
//     if (response.data.url) {
//       return response.data.url; // 성공적으로 URL 반환
//     } else {
//       return ''; // URL이 없는 경우 빈 문자열 반환
//     }
//   } catch (error) {
//     console.error('Error fetching image URL:', error);
//     return ''; // 오류 발생 시 빈 문자열 반환
//   }
// }



async function getS3PathLong(imagePath, sec=600) {

  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}


async function getS3PathShort(imagePath, sec=1) {
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



async function getS3PathVideo(imagePath, sec=60000) {
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



//GET방식은 param값을 서버에서 못 가져와서 POST 방식으로 변경
async function fetchImageUrl(imagePath, sec) {
  // const url = `https://kuebs.org/api/get-image-path`;//서버일 때 (proxy)
  // const url = `http://localhost:8000/get-image-path`;//로컬일 때
  const url = `${svrUrl}/get-image-path`;
  try {
    const res = await axios.post(url, {imagePath, sec });
    if (res.data.url) {
      return res.data.url;
    } else {
      return '';
    }
  } catch (error) {
    console.error('Error fetching image URL:', error);
    return '';
  }
}



 // 파일 업로드 핸들러
 const fileUpload = async (selectedFile, filePath, callback) => {
  if (!selectedFile) {
    alert('파일을 선택해주세요!');
    return;
  }

  try {
    // FormData를 생성하여 파일 추가
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('filePath', filePath);

    // 서버 API 호출 (백엔드에서 S3 업로드 처리)
    const response = await fetch(`${svrUrl}/uploadFile`, {
      method: 'POST',
      body: formData,
    });

    if (response.ok) {
      const res = await response.json(); // S3 경로 응답
      // console.log(res,'============== res');
      callback(res);
    } else {
      // setUploadMessage('업로드 실패!');
    }
  } catch (error) {
    // console.error('업로드 중 오류 발생:', error);
      //  alert('업로드 중 오류가 발생했습니다.');
      callback({result: 'fail'});
  }
};


// JSON 업로드 핸들러
const fileUpload_json = async (jsonData, filePath, callback) => {
  if (!jsonData || !filePath) {
    alert('JSON 데이터와 파일 경로를 입력해주세요!');
    return;
  }

  try {
    // 서버 API 호출 (백엔드에서 S3 업로드 처리)
    const response = await fetch(`${svrUrl}/uploadJson`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // JSON 데이터 전송을 위한 헤더 설정
      },
      body: JSON.stringify({ jsonData, filePath }), // JSON 데이터와 파일 경로를 요청 본문에 포함
    });

    if (response.ok) {
      const res = await response.json(); // S3 경로 응답
      callback(res);
    } else {
      console.error('업로드 실패:', response.statusText);
      callback({ result: 'fail', error: response.statusText });
    }
  } catch (error) {
    console.error('업로드 중 오류 발생:', error);
    callback({ result: 'fail', error: error.message });
  }
};

// JSON 업로드 핸들러
const fileDelete_json = async (filePath, callback) => {
  if (!filePath) {
    alert('파일 경로를 입력해주세요!');
    return;
  }

  try {

    const response = await fetch(`${svrUrl}/deleteJson`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // JSON 데이터 전송을 위한 헤더 설정
      },
      body: JSON.stringify({ filePath }), // JSON 데이터와 파일 경로를 요청 본문에 포함
    });

    if (response.ok) {
      const res = await response.json(); // S3 경로 응답
      callback(res);
    } else {
      console.error('파일삭제 실패:', response.statusText);
      callback({ result: 'fail', error: response.statusText });
    }
  } catch (error) {
    console.error('파일삭제 중 오류 발생:', error);
    callback({ result: 'fail', error: error.message });
  }
};


// 파일을 Presigned URL로 직접 업로드하는 함수
async function axiosPutFile(url, file) {
  try {
    const response = await axios.put(url, file, {
      headers: {
        'Content-Type': file.type
      }
    });
    return response;
  } catch (error) {
    console.error('axiosPutFile 업로드 실패:', error);
    throw error;
  }
}

/**
 * S3 파일 삭제 함수
 * @param {string} filePath - 삭제할 파일의 S3 경로
 * @returns {Promise<object>} - 서버 응답 객체
 */
async function deleteS3File(s3Key) {
  if (!s3Key) {
    throw new Error('filePath is required');
  }
  const url = `${svrUrl}/delete-upload-file`;
  try {
    const response = await axios.post(url, { s3Key });
    return response.data;
  } catch (error) {
    console.error('Error deleting S3 file:', error);
    return { result: 'fail', error: error.message };
  }
}

  
const fncS4 = { 
  getS3Path, getS3PathLong, getS3PathShort, getS3PathVideo, getS3PathDownLoad_rename,
  fileUpload, fileUpload_json, fileDelete_json, axiosPutFile, deleteS3File
 }

export default fncS4;
// module.exports = fnc;
// 
